import React from 'react'
import { connect } from 'react-redux'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import {
  EmarModuleCard,
  FamilyPlanModuleCard,
  PaywallTemplate,
} from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { HomeSource } from '@lmc/ts-common'
import { colours } from '@lmc/ui-kit/src/config/theme'
import { getNominative } from 'common/utils'

interface StateProps {
  subscribeTo: () => void
  getSubscriptions: () => void
  subscriptionCancelled?: boolean
  role?: string
  title?: string
  subTitle?: string
  source?: HomeSource
  preferredPeopleNominative?: string
}

export const AboutMePaywallComponent: React.FC<StateProps> = ({
  subscribeTo,
  getSubscriptions,
  subscriptionCancelled,
  role,
  source,
  preferredPeopleNominative,
}) => {
  React.useEffect(() => {
    getSubscriptions()
  }, [])

  const ctaDisabled = role === 'senior-carer' || subscriptionCancelled
  let disabledText
  if (subscriptionCancelled) {
    disabledText = 'Note: Sorry, you have already completed a free trial.'
  } else if (role === 'senior-carer') {
    disabledText = 'Note: Only admins can start a free trial.'
  }

  return (
    <PaywallTemplate
      backgroundColor={colours.status.popout}
      title="About Me"
      subTitle="Bring the person to the forefront of your care and minimise risks with this extended set of questions attached to the profile designed to capture the voice, needs and challenges of your service user."
      bodyText={`Use ‘About me’ to empower your ${getNominative(
        preferredPeopleNominative,
        'resident'
      ).toLowerCase()}`}
      cta="Start Free Trial"
      onClick={subscribeTo}
      icon={IconType.DocsHexagon}
      videoUrl="https://www.youtube.com/embed/2XCgAbKwzvQ"
      articles={[
        {
          title: 'From good to outstanding with LMC',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://www.logmycare.co.uk/blog/from-good-to-outstanding-with-log-my-care',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white,
        },
        {
          title: 'What features can I access with Pro?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.green,
          iconColour: colors.white,
        },
        {
          title: 'How much does it cost?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/articles/1584269-how-much-does-it-cost',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white,
        },
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      ctaDisabled={ctaDisabled}
      disabledText={disabledText}
      findOutMoreURL="https://logmycare.co.uk/pricing"
      source={source}
      customLinkText="Read more"
    />
  )
}

const mapStateToProps = (state: any) => ({
  subscriptionCancelled: Selectors.isSubscriptionCancelled(
    state,
    'pro-monthly'
  ),
  role: state.global?.user?.role,
  source: state.global?.home?.source,
  preferredPeopleNominative: state.global?.home?.preferredPeopleNominative,
})

const mapDispatchToProps = (dispatch: any) => ({
  subscribeTo: () =>
    dispatch(
      Operations.openNewPlan({
        planId: 'pro-monthly',
      })
    ),
  getSubscriptions: () => dispatch(Operations.getSubscriptions()),
})

export const AboutMePaywall = connect(
  mapStateToProps,
  mapDispatchToProps
)(AboutMePaywallComponent)
